import React from 'react'

function Error() {
  return (
    <div>Something went Wrong!</div>
  )
}

export default Error
